<template>
  <div class="p-4">
    <div class="flex flex-wrap justify-between">
      <div class="my-5">
        <b>Request Details</b>
        <p class="py-2">
          Service Type:
          <abbr class="font-semibold capitalize">{{ checkTerminalType }}</abbr>
        </p>
        <p>
          From: <abbr class="font-semibold">{{ fullSenderAddress }}</abbr> |
          <abbr class="font-semibold">{{ fullRecieverAddress }}</abbr>
        </p>
      </div>

      <div class="w-full pb-10">
        <div class="flex items-center">
          <i class="w-6"><base-checkbox class="py-0" v-model="isAddress" @input="isAddress = !isAddress" /></i>
          <span class="mx-1">Add Return Address / Forwarding Address</span>
          <tool-tip text="Shipper is the person or company who supplies the commodity to be shipped." />
        </div>
        <vue-google-autocomplete id="map2" ref="address" :disabled="!isAddress" classname="input"
          placeholder="Enter address" :value="fullAddress" v-on:placechanged="setAddress">
        </vue-google-autocomplete>
      </div>
    </div>

    <div v-if="!shippingServiceLoading && viewDispatcherService"
      class="flex flex-wrap px-0 options_filter border-dashed border-gray-500 pb-2 sorter_option rounded-md">
      <div :style="{ width: '25%' }" class="pt-2">
        <form-select :ref="refCarier" placeholder="Sort by Carrier" color="#7A90A7" bgColor="white" border="0px" class="border-0 w-full">
          <b-form-checkbox v-for="carrier in carriers" :key="carrier" :name="carrier" :value="carrier"
            v-model="orgnameFilter" :label="carrier">
            {{ carrier }}
          </b-form-checkbox>
        </form-select>
      </div>
      <div :style="{
            marginTop: '10px',
            border: '1px dashed #4142455C',
            position: 'relative',
            top: '5px',
          }" class="h-6"></div>

      <div :style="{ width: '24%' }" class="pt-2">
        <form-select placeholder="Sort by Categories" color="#7A90A7" bgColor="white" border="0px"
          class="border-0 w-full">
          <b-form-checkbox v-for="category in category" :key="category" :name="category" :value="category"
            v-model="categoryFilter" :label="category">
            {{ category }}
          </b-form-checkbox>
        </form-select>
      </div>

      <div :style="{
            marginTop: '10px',
            border: '1px dashed #4142455C',
            position: 'relative',
            top: '5px',
          }" class="h-6"></div>

      <div :style="{ width: '25%' }" class="pt-2">
        <form-select placeholder="Sort by Cost" color="#7A90A7" bgColor="white" border="0px" class="border-0 w-full">
          <b-form-checkbox v-for="cost in costSort" :key="cost" :name="cost" :value="cost" v-model="costFilter"
            :label="cost">
            {{ cost }}
          </b-form-checkbox>
        </form-select>
      </div>

      <div :style="{
            marginTop: '10px',
            border: '1px dashed #4142455C',
            position: 'relative',
            top: '5px',
          }" class="h-6"></div>

      <div :style="{ width: '25%' }" class="pt-2">
        <form-select :multiple="false" color="#7A90A7" placeholder="Sort by Timeline" bgColor="white" border="0px"
          class="border-0 w-full">
          <b-form-checkbox v-for="timeline in timeline" :key="timeline" :name="timeline" :value="timeline"
            v-model="timeline_"
            :label="timeline">
            {{ timeline }}
          </b-form-checkbox>
        </form-select>
      </div>
    </div>

    <div class="w-full pb-10 flex flex-wrap my-4" v-if="viewDispatcherService">
      <label class="label">Select Shipping Service</label>
      <div v-if="shippingServiceLoading" class="grid h-64 w-full place-items-center">
        <span class="loader">
          <img src="@/assets/images/ondemand/loader.svg" /></span>
      </div>
      <div v-if="!shippingServiceLoading" class="overflow-auto whitespace-nowrap">
        <div v-for="(item, index) in filteredShippingService" class="mr-2 my-2 zoom cursor-pointer" :key="index"
          @click="setShippingService(index)" :class="[selectedIndex == index ? 'active-tab' : 'dull-tab']">
          <p class="opacity-75 text-primary-yellow font-semibold flex justify-center items-center mb-2">
            <span class="flex items-center justify-items-center py-1 border-b-2 border-gray-400">
              <img src="   " class="mr-2 rounded-full w-6 h-6 bg-primary-navy" />{{ item.orgName }}
            </span>
          </p>
          <p class="text-sm uppercase">
            {{ item.costData ? item.costData.costTye : "--" }}
          </p>
          <p class="py-1">
            <b class="big-text"><sup>₦</sup>
              {{ amountFomatter(item.costData.totalCost || 0) }}</b>
          </p>
          <p class="opacity-50 py-1 text-sm border-b-2 border-gray-400">
            Two-Way Total
          </p>
          <p>
            {{ item.costData ? item.costData.literature : "N/A" }}
          </p>
          <p class="mt-3 opacity-50">
            Arrives Friday, 12/02
          </p>
        </div>
      </div>
      <div class="text-base text-red-600 w-full justify-center flex py-8"
        v-if="!shippingServiceLoading && !filteredShippingService.length">
        <b>No Fleet Available, for the selected locations</b>
      </div>
    </div>

    <div class="w-full pb-10 flex flex-wrap my-4" v-else>
      <label class="label">Select Fleet</label>
      <div v-if="shippingServiceLoading" class="grid h-64 w-full place-items-center">
        <span class="loader">
          <img src="@/assets/images/ondemand/loader.svg" /></span>
      </div>

      <div class="text-base text-red-600 w-full justify-center flex py-8"
      v-if="!shippingServiceLoading && !dispatcherFleets.length">
      <b>No Fleet Available, for the selected locations</b>
    </div>

      <div v-if="!shippingServiceLoading" class="overflow-auto whitespace-no-wrap">
        <div v-for="(item, index) in dispatcherFleets" class="mr-2 my-2 zoom cursor-pointer" :key="index"
          @click="setShippingServiceForDOD(index)" :class="[selectedIndex == index ? 'active-tab' : 'dull-tab']">
          <p class="opacity-75 text-primary-yellow font-semibold flex justify-center items-center mb-2">
            <span class="flex items-center justify-items-center py-1 border-b-2 border-gray-400 w-full justify-center">
              {{ item.vehicleType }}
            </span>
          </p>
          <p class="py-1">
            <b class="big-text"><sup>₦</sup>
              {{ amountFomatter(item.cost || 0) }}</b>
          </p>
          <p class="opacity-50 py-1 text-sm ">
            Two-Way Total
          </p>
          <div class=" w-full flex items-center justify-around pb-2 set_height">
            <button v-if="item.isCheapest" class="py-1 px-2 text-sm bg-primary-yellow rounded-xl">Cheapest</button>
            <button v-if="item.isFastest" class="py-1 px-2 text-sm bg-primary-green rounded-xl">Fastest</button>
          </div>
          <!-- <p class="mt-3 opacity-50">
            Arrives, {{ item.duration }}
          </p> -->
        </div>
      </div>
    </div>

    <div v-if="loaded && !shippingServiceLoading" class="flex justify-center flex-wrap">
      <b class="blcok w-full text-center text-red-600">Error occured, unable to get shipping service</b>
      <button @click="refresh()">Retry</button>
    </div>


    <div class="flex items-center justify-between py-4 px-4">
      <button class="underline" @click="$emit('changeBookingTab', 3)">
        Back
      </button>
      <primary-button class="shadow-md font-normal" buttonText="Continue" :loading="loading"
        :disabled="selectedIndex == undefined" :class="[selectedIndex != undefined ? 'opacity-100' : 'opacity-50']"
        @click="submitPrefrence" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import formater from "@/utilities/formatter.js";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { VueGoogleAutocomplete },
  data() {
    return {
      isAddress: false,
      cost: {},
      pickUpTime_1: "",
      pickUpTime_2: "",
      deliveryTime_1: "",
      deliveryTime_2: "",
      loading: false,
      selectedCost: {},
      shippingService: [],
      shippingServiceId: "",
      locations: [],
      costId: undefined,
      shippingServiceOrgId: undefined,
      dropOff: undefined,
      pickUp: undefined,
      showLocations: false,
      categoryFilter: "All",
      costFilter: "All",
      orgnameFilter: "All",
      termimalToDoorCost: {},
      filteredShippingService: [],
      loaded: false,
      prefrence: {
        terminalAddress: "",
        pickUpDays: undefined,
        deliveryDays: undefined,
        dropOff: undefined,
        pickUp: undefined,
        paymentStatus: false,
        userId: localStorage.getItem("userId"),
        shipperLocationId: this.$store.getters.latestNewBooking.shipper.id,
        consigneeLocationId: this.$store.getters.latestNewBooking.consignee.id,
        pickUpTime: [],
        deliveryTime: [],
        id: this.$store.getters.latestNewInitialShipping?.id,
        returnOrForwardingAddress: undefined,
      },
      startIndex: -1,
      endIndex: -1,
      deliveryCode: "code",
      address: "",
      center: { lat: 43.3, lng: 10.3 },
      origin: {},
      timeline: ["All", "24hrs Delevery", "48hrs Delivery", "One Week"],
      timeline_: "",
      costSort: [
        "All",
        "0 - 1,000",
        "1,000 - 2,000",
        "2,000 - 3,000",
        "4,000 - 5,000",
      ],
      category: ["All", "Economy", "Standard", "Express"],
      carriers: ["All", "ABC", "GIG", "YSG", "Chisco"],
      carrierFilter: [],
      shippingServiceLoading: true,
      selectedIndex: undefined,
      dispatcherFleets: []
    };
  },
  activated() {
    this.shippingService = [];
    this.cost = [];
    this.getShippingService();
    this.shippingServiceId = null;
    this.costId = null;
    this.selectedIndex = null;
    this.fetchVehicleWithCost()
  },
  computed: {
    vehiclePayload() {
      let shipper = {}
      let reciever = {}
      if (this.activeShipping?.shipper?.alternativeAddress?.lat) {
        shipper = this.activeShipping?.shipper?.alternativeAddress
      }
      shipper = this.activeShipping?.shipper?.address

      if (this.activeShipping?.consignee?.alternativeAddress?.lat) {
        reciever = this.activeShipping?.consignee?.alternativeAddress
      }
      reciever = this.activeShipping?.consignee?.address

      return {
        origin: {
          latitude: shipper.lat,
          longitude: shipper.lng,
        },
        destination: {
          latitude: reciever.lat,
          longitude: reciever.lng,
        },
        shippingId: this.$store.getters.latestNewInitialShipping?.id,
        type: "single",
      };
    },
    viewDispatcherService() {
      //code to check if the state are the same
      // const states = this.$store.getters.getBookingStates;
      // const checktype =
      //   states.reciever === states.sender &&
      //   (this.checkTerminalType !== "terminal-to-terminal" || this.checkTerminalType !== "terminal-to-door") ;
      const checktype = (this.checkTerminalType == "terminal-to-terminal" || this.checkTerminalType == "terminal-to-door") ;
      return checktype;
    },
    filterPayload() {
      let cost =
        this.costFilter != "All"
          ? this.costFilter
            .replace(/,/g, "")
            .split(" - ")
            .map(Number)
          : "All";
      return {
        category: this.categoryFilter == "All" ? "" : this.categoryFilter,
        cost: cost == "All" ? "" : [cost[0], cost[1]],
        orgName: this.orgnameFilter == "All" ? "" : this.orgnameFilter,
        timeline: this.timeline_ == "All" ? "" : this.timeline_,
      };
    },
    checkTerminalType() {
      return `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
    },
    fullSenderAddress() {
      if (this.activeShipping?.shipper?.alternativeAddress?.lat) {
        return this.extractAddress(
          this.activeShipping?.shipper?.alternativeAddress
        );
      }
      return this.extractAddress(this.activeShipping?.shipper?.address);
    },
    fullRecieverAddress() {
      if (this.activeShipping?.consignee?.alternativeAddress?.lat) {
        return this.extractAddress(
          this.activeShipping?.consignee?.alternativeAddress
        );
      }
      return this.extractAddress(this.activeShipping?.consignee?.address);
    },
    fullAddress() {
      return this.extractAddress(this.prefrence.address);
    },
    // origin(){
    //   return {
    //     lat: Number( this.$store.getters.latestNewBooking?.shipper?.address?.lat),
    //     lng: Number( this.$store.getters.latestNewBooking?.shipper?.address?.lng)
    //   }
    // },
    destination() {
      return {
        lat: Number(
          this.$store.getters.latestNewBooking?.consignee?.address?.lat
        ),
        lng: Number(
          this.$store.getters.latestNewBooking?.consignee?.address?.lng
        ),
      };
    },
    terminalAddress() {
      return (
        this.$store.getters?.latestNewBooking?.consignee?.address?.name ?? ""
      );
    },
    createChangesWatch() {
      return this.$store.getters.getBookingChangesindicator;
    },
    checkTerminallocation() {
      return this.prefrence.pickUp && this.prefrence.dropOff;
    },
    activeShipping() {
      return this.$store.getters.latestNewBooking;
    },
    isDropOff() {
      return this.prefrence.shippingMethod == "terminal-to-terminal";
    },
    isCostId() {
      return this.costId == undefined ? false : true;
    },
    costPayload() {
      return {
        shippingId: this.$store.getters.latestNewInitialShipping?.id,
        shippingServiceId: this.shippingServiceId,
        type: "single",
      };
    },
    payload() {
      return {
        ...this.prefrence,
        dropOff: this.prefrence.dropOff,
        pickUp: this.prefrence.pickUp,
        pickUpDays:
          this.prefrence.pickUpDays && !this.isDropOff
            ? moment(this.prefrence.pickUpDays).format("YYYY-MM-DD")
            : undefined,
        deliveryDays:
          this.prefrence.deliveryDays && !this.isDropOff
            ? moment(this.prefrence.deliveryDays).format("YYYY-MM-DD")
            : undefined,
        shippingServiceId: this.shippingServiceId,
      };
    },
    pickUpTimeFormat() {
      return [
        this.pickUpTime_1 && !this.isDropOff
          ? moment(this.pickUpTime_1).format("HH:mm")
          : null,
        this.pickUpTime_2 && !this.isDropOff
          ? moment(this.pickUpTime_2).format("HH:mm")
          : null,
      ];
    },
    deliveryTimeFormat() {
      return [
        this.deliveryTime_1
          ? moment(this.deliveryTime_1).format("HH:mm")
          : null,
        this.deliveryTime_2
          ? moment(this.deliveryTime_2).format("HH:mm")
          : null,
      ];
    },
  },
  mounted() {
    this.geolocate();
    this.prefrence = {
      ...this.prefrence,
    };
    this.setinitialShippingService();
    this.getAllLocation();
  },
  watch: {
    orgnameFilter(){
     this.$ref.refCarier.click()
    },
    costFilter() { },
    filterPayload() {
      let filteredShippingService = this.shippingService.filter((item) => {
        return (
          item.costData.costTye.includes(this.filterPayload.category) &&
          item.orgName.includes(this.filterPayload.orgName) && 
          item.costData.literature.includes(this.filterPayload.timeline)
        );
      });
      if (Array.isArray(this.filterPayload.cost)) {
        this.filteredShippingService = filteredShippingService.filter(
          (item) =>
            item.costData.totalCost >= this.filterPayload.cost[0] &&
            item.costData.totalCost <= this.filterPayload.cost[1]
        );
      } else {
        this.filteredShippingService = filteredShippingService;
      }
    },
    checkTerminallocation() {
      this.prefrence.pickUp && this.prefrence.dropOff
        ? this.getShippingService()
        : null;
    },
    costPayload() {
      this.getCostEngine();
    },
    shippingServiceId() {
      this.getAllLocation();
      this.updateShipping();
      this.showLocations = true;
    },
  },
  methods: {
    refresh() {
     this.getShippingService()
    },
    async fetchVehicleWithCost() {
      try {
        const response = await this.$_getVehicleWithCost(this.vehiclePayload);
        this.dispatcherFleets = response.data.options
      } catch (error) {
        //
      }
    },
    setAddress(addressData) {
      this.prefrence = {
        ...this.prefrence,
        address: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
          street_number: addressData?.street_number,
          locality: addressData?.locality,
          country: addressData.country,
          adm_1: addressData?.administrative_area_level_1,
          adm_2: addressData?.administrative_area_level_2,
        },
      };
    },
    returnML(val) {
      return val?.locationName + " (" + val?.Org?.companyname + ")";
    },
    async miniUpdateShipping() {
      let consigneeAdd = this.$store.getters.latestNewBooking.consignee.address;
      let dropOff = this.locations.takeOffLocation.find(
        (x) => x.id == this.prefrence.dropOff
      );

      (this.origin = {
        lat: Number(dropOff.lat),
        lng: Number(dropOff.long),
      }),
        (this.center = {
          lat: consigneeAdd.lat ? consigneeAdd.lat : 10.34,
          lng: consigneeAdd.lng ? consigneeAdd.lng : 7.23,
        });
    },
    geolocate: function () {
      this.origin = {
        lat: Number(
          this.$store.getters.latestNewBooking.shipper?.address.lat ?? 0
        ),
        lng: Number(
          this.$store.getters.latestNewBooking.shipper?.address.lng ?? 0
        ),
      };
    },
    async getCostEngineByShipping() {
      const payload = {
        shippingId: this.$store.getters.latestNewInitialShipping?.id,
        type: "single",
      };

      try {
        const response = await this.$_getCostEngineByShipping(payload);
        this.termimalToDoorCost = {};
        this.termimalToDoorCost = response.data.data?.standardCost;
        this.$store.dispatch(
          "saveLatestNewCostEngine",
          this.termimalToDoorCost
        );
        this.costId = 1;
      } catch (error) {
        this.handleError(error);
      }
    },
    setPlace(place) {
      console.log(place);
    },
    async updateShippingTerminal(val) {
      let payload = this.payload;
      payload.dropOff = val;
      await this.$_createShippingId({
        payload: { ...this.payload },
      });
    },
    async createShipping() {
      try {
        let response = await this.$_createShippingId({
          payload: { ...this.payload },
        });
        this.$store.dispatch(
          "saveLatestNewInitialShipping",
          response.data.data.shipping
        );
      } catch (error) {
        this.handleError(error);
      }
    },
    setinitialShippingService() {
      this.isDOD() ? this.getShippingService() : (this.shippingService = []);
      this.cost = [];
    },
    async updateShipping() {
      let updateShippingPayload = {
        id: this.$store.getters.latestNewBooking?.initialShipping?.id,
        orgId: this.shippingServiceOrgId,
      };
      try {
        await this.$_createShippingId({
          payload: { ...updateShippingPayload },
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    setShippingService(index) {
      const selectedShippingService = this.filteredShippingService[index];
      this.shippingServiceId = selectedShippingService.id;
      this.selectedIndex = index;
      this.shippingServiceOrgId = selectedShippingService?.orgId;
      this.$store.dispatch(
        "saveLatestNewCostEngine",
        selectedShippingService?.costData
      );
    },
    setShippingServiceForDOD(index) {
      const selectedShippingService = this.dispatcherFleets[index];
      this.selectedIndex = index;
      this.$store.dispatch(
        "saveLatestNewCostEngine",
        selectedShippingService
      );
    },
    async updateTransaction(id, payload) {
      try {
        await this.$_updateTransaction(id, payload);
      } catch (error) {
        //
      }
    },
    costEngineSet(index) {
      this.costId = index;
      let singleCost = {
        ...Object.values(this.cost)[index],
        type: Object.keys(this.cost)[index].replace("Cost", ""),
      };
      this.selectedCost = {
        totalValue: singleCost?.totalCost,
        shippingPackage: Object.keys(this.cost)[index].replace("Cost", ""),
      };
      this.$store.dispatch("saveLatestNewCostEngine", singleCost);
    },
    getCostEngine() {
      try {
        this.$_getCostEngine(this.costPayload).then((response) => {
          this.cost = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    formatNum(val) {
      return formater(val);
    },
    async getAllLocation() {
      const payload = {
        arrivalLocation: {
          lat: this.activeShipping?.consignee?.address?.lat,
          lng: this.activeShipping?.consignee?.address?.lng,
        },
        takeOffLocation: {
          lat: this.activeShipping?.shipper?.address?.lat,
          lng: this.activeShipping?.shipper?.address?.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);
        this.locations = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async submitPrefrence() {
      this.loading = true;
      try {
        const response = await this.$_createShippingId({
          payload: this.payload,
        });
        this.$store.dispatch(
          "saveLatestNewShippingInfo",
          response.data.data.shipping
        );
        this.updateTransaction(response.data.data.shipping?.transactionId, {
          payload: { ...this.selectedCost },
        });
        this.$emit("changeBookingTab", 5);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getShippingService() {
      this.shippingServiceLoading = true;
      try {
        let payload = {
          shipperLocationId: this.$store.getters.latestNewBooking.shipper?.id,
          consigneeLocationId: this.$store.getters.latestNewBooking.consignee
            ?.id,
          shippingId: this.$store.getters.latestNewInitialShipping?.id,
          shipmentType: "single",
          terminalType: this.checkTerminalType,
        };
        await this.newGetShippingServiceByRoute(payload).then((response) => {
          this.shippingService = response.data.data.shippingServices.filter(
            (item) => item
          );
          this.filteredShippingService = response.data.data.shippingServices.filter(
            (item) => item
          );
          this.carriers = Array.from(
            new Set([
              "All",
              ...this.shippingService.map((item) => {
                return item.orgName;
              }),
            ])
          );
        });
      } catch (error) {
        this.handleError(error);
        this.loaded = true
      } finally {
        setTimeout(() => {
          this.shippingServiceLoading = false;
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  @apply block w-full py-2;
}

.active-days {
  @apply inline-block uppercase px-2 py-2 bg-primary-yellow mx-1 rounded-md;
  margin-bottom: 1em;
}

.sh-active-days {
  @apply inline-block uppercase px-2 py-2 bg-primary-yellow mx-1 opacity-50 cursor-pointer rounded-md mb-2;
}

.dull-days {
  @apply inline-block uppercase px-4 py-2 bg-gray-300 text-gray-500 mx-1 cursor-not-allowed rounded-md mb-2;
}

.radio-label {
  span {
    top: 10px;
  }
}

.text-field {
  @apply bg-gray-100 px-3 border-2 border-gray-200 rounded-sm;
}

.dull-tab {
  @apply p-3 border-2 border-gray-400 bg-gray-100 text-center py-8 duration-300;
  width: 230px;
}

.active-tab {
  width: 230px;
  @apply p-3 border-2 border-gray-400 bg-primary-navy text-white text-center py-8 duration-300;
}

.big-text {
  font-size: 35px;
  font-weight: 500;
}

.divider {
  @apply border-2 border-gray-400 my-2;
}

input:disabled {
  cursor: not-allowed;
}

.zoom {
  transition: 0.6s;
  display: inline-block;
  margin-left: 5px;
  transform: scale(1);
}

.zoom:hover {
  transform: scale(1.03);
}

.el-select {
  margin-bottom: 0;
  margin: 0.5em 0;
}

.el-input__inner {
  border: none !important;
}

.options_filter {
  border-width: 1px;
}

.select-box {
  @apply flex items-center justify-between bg-gray-200 py-4 px-2 duration-300 cursor-pointer;
  width: 24%;
}

.select-box-active {
  @apply bg-primary-navy text-white;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
}

.options_filter div:nth-of-type(4) {
  border-width: 0px;
}

.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 1s infinite linear rolls;
}

@keyframes rolls {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.set_height {
  height: 40px
}
</style>
